
import { Component, inject, signal, type WritableSignal } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { MessageModule } from 'primeng/message';
import { Card } from '../../../shared/components/card/card/card';
import { Navbar } from '../../../shared/components/navbar/navbar';
import { Router } from '@angular/router';
import type { MenuItem } from 'primeng/api';
import type { User } from '../../../interfaces/user';
import { UserService } from '../../../services/user.service';
import { PanelMenuModule } from 'primeng/panelmenu';

@Component({
  selector: 'app-forbidden',
  imports: [
    Navbar,
    Card,
    DividerModule,
    MessageModule,
    PanelMenuModule
],
  templateUrl: './forbidden.html',
  styleUrl: './forbidden.css',
})
export class Forbidden {

  private readonly _router: Router = inject(Router);
  private readonly _userService: UserService = inject(UserService);

  public menuItems: MenuItem[] = [];
  public user: WritableSignal<User|null> = signal<User|null>(null);

  public ngOnInit(): void {
    this._getUser();
  }

  private _getUser(): void {
    this._userService.me()
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.user.set(response.data);
            this._initMenuItems();
          }
        },
      })
  }

  private _userHasPermission(permission: string): boolean {
    return this.user()?.roles.some(role => role.permissions.some(p => p.name === permission)) || false;
  }

  private _initMenuItems(): void {
    this.menuItems = [
      {
        label: 'Dashboard',
        icon: 'fa-solid fa-grip',
        badge: '',
        url: 'dashboard',
        action: () => this._router.navigate(['dashboard']),
        visible: this._userHasPermission('view dashboard'),
        items: [],
      },
      {
        label: 'Relatórios e Análises',
        icon: 'fa-solid fa-chart-line',
        badge: '',
        url: 'reports',
        action: () => {},
        items: [
          {
            label: 'Cohort',
            icon: 'fa-solid fa-chart-column',
            badge: '',
            url: 'reports/cohort',
            action: () => this._router.navigate(['reports', 'cohort']),
            visible: this._userHasPermission('view reports cohort'),
          }
        ],
      },
      {
        label: 'Extrato',
        icon: 'fa-solid fa-receipt',
        badge: '',
        url: 'statements',
        action: () => this._router.navigate(['statements']),
        visible: this._userHasPermission('view statements'),
        items: [],
      },
      {
        label: 'Área de Pagamentos',
        icon: 'fa-solid fa-money-bill-wave',
        badge: '',
        url: 'payments',
        action: () => this._router.navigate(['payments']),
        visible: this._userHasPermission('view payments'),
        items: [],
      },
      {
        label: 'Contratos',
        icon: 'fa-solid fa-scale-unbalanced-flip',
        badge: '',
        url: 'contracts',
        action: () => this._router.navigate(['contracts']),
        visible: this._userHasPermission('view contracts'),
        items: [],
      },
      {
        label: 'Comunicados',
        icon: 'fa-regular fa-message',
        badge: '',
        url: 'announcements',
        action: () => this._router.navigate(['announcements']),
        visible: this._userHasPermission('view announcements'),
        items: []
      },
    ];
  }
}
